import {getUserResponseStatusError} from '../../../api/getErrorByType';
import {ErrorEvent, IErrorEvent} from '../../../api/network';
import {api} from '../../../api/proto';

export default function getResendConfirmEmail(error?: IErrorEvent | null, res?: api.IResendConfirmEmailResponse | null): IErrorEvent | null {
  if (error) {
    return error;
  }

  const message = getUserResponseStatusError('resendConfirmEmail', res?.status);
  if (message) {
    return new ErrorEvent({message});
  }

  return null;
}
